import { Chip, Stack } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { useSelector } from '@lingoda/hooks';
import { livePracticeLinkSelector } from '@lingoda/modules';
import { LinkTab } from './LinkTab';
import type { TabCommonProps } from './types';

export const LivePractice = (props: TabCommonProps) => {
    const link = useSelector(livePracticeLinkSelector);

    return (
        <LinkTab
            to={link}
            target="_blank"
            track="LivePractice"
            label={
                <Stack direction="row" alignItems="center">
                    {trans('navigation.user.livePractice', {}, 'public-common')}
                    <Chip
                        color="promotion"
                        sx={{ marginLeft: 1 }}
                        label={trans('new', {}, 'public-common')}
                    />
                </Stack>
            }
            {...props}
        />
    );
};
